import * as React from 'react';
import RenderGallery from 'vkid-ui/lib/Components/RenderGallery';
import Gallery from './Gallery';
import ReactDOMServer from 'react-dom/server';
import { useProductContext } from '../../../../../contexts/ProductContext';

const ProductGallery: React.FC = () => {
    const { images, initialGalleryHtml, productConfig, oldPrice } = useProductContext();
    // Determine which gallery content to use
    let galleryHtml: string | undefined;

    if (images && images.length > 0) {
        // Use images from product configuration change
        galleryHtml = ReactDOMServer.renderToString(<Gallery productName={productConfig.name} images={images} />);
    } else if (initialGalleryHtml) {
        // Use initial gallery HTML from DOM
        galleryHtml = initialGalleryHtml;
    }

    if (!galleryHtml) {
        return null;
    }

    return (
        <React.Fragment>
            {oldPrice && <div className="product-sale">%</div>}
            <RenderGallery
                dom={galleryHtml}
                config={{
                    showThumbs: true,
                    showArrows: true,
                    showIndicators: false,
                    hasOverlay: true,
                }}
            />
        </React.Fragment>
    );
};

export default ProductGallery;
